const firebaseConfig = {
  apiKey: "AIzaSyCKj_pvfRx5heghCycGzwM5-P2StwBOsqM",
  authDomain: "cryptohunter12.firebaseapp.com",
  projectId: "cryptohunter12",
  storageBucket: "cryptohunter12.appspot.com",
  messagingSenderId: "604147237606",
  appId: "1:604147237606:web:075e81b0d4dfd937ef7127",
};

export default firebaseConfig;
